<template>
  <div id="app">
    <!-- :include="showAnswers" -->
 <keep-alive >
<router-view v-if="$route.meta.keepAlive"></router-view>
 </keep-alive>
 <router-view v-if="!$route.meta.keepAlive" ></router-view> 
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>

<style lang="less">
html,
body,
#app {
  height: 100%;
}
</style>
